/* @flow */
import { About } from './services'
import _ from 'lodash'

/**
 * Returns a Promise that will resolve (kind of like noop Promise).
 * You would use this if you were creating a non-blocking/asynchronous API on top of synchronous code.
 * Or if you envisaged blocking code becoming asynchronous in the future, but didn't want to implement that just yet.
 */
export function fakePromise(resolveWith: any = null, rejectWith: any = null): Promise<any> {
  if (rejectWith) return Promise.reject(rejectWith)
  return Promise.resolve(resolveWith)
}

/**
 * Better URI encoding.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 */
export function fixedEncodeURIComponent(str: string) {
  return encodeURIComponent(str).replace(/[!'()*]/g, c => {
    return '%' + c.charCodeAt(0).toString(16)
  })
}

/**
 * Return the current version of Cuesta.
 * Note: The actual version will get set as part if the CI build process.
 */
export function about() {
  return About.kwanza().then(k => {
    return {
      name: k.Name,
      version: { cuesta: '1.15.4', kwanza: k.Version },
      color: k.Color,
      features: k.Features,
      env: k.Env
    }
  })
}

export function isDeepEmpty(object: Object) {
  return _.isEmpty(object) || !Object.values(object).some(x => !_.isEmpty(x))
}

export function byteLength(str: string) {
  // from https://stackoverflow.com/a/23329386
  // returns the byte length of an utf8 string
  var s: number = (str && str.length) || 0
  /*for (var i = str.length - 1; i >= 0; i--) {
        var code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xdc00 && code <= 0xdfff) i-- //trail surrogate
      }*/

  // convert to a human readable value
  return prettySize(s)
}

export function prettySize(s: number) {
  if (!s || s <= 0) return '0 B'
  var i = Math.floor(Math.log(s) / Math.log(1024))
  return (s / Math.pow(1024, i)).toFixed(1) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}
